import { render, staticRenderFns } from "./KoioteTabla.vue?vue&type=template&id=6a96a480&scoped=true"
import script from "./KoioteTabla.vue?vue&type=script&lang=js"
export * from "./KoioteTabla.vue?vue&type=script&lang=js"
import style0 from "./KoioteTabla.vue?vue&type=style&index=0&id=6a96a480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a96a480",
  null
  
)

export default component.exports